export const BURL = 'https://server.apartmential.com/api/';